import { Component, EventEmitter, Input, Output } from '@angular/core';

import { routes } from '../../../../consts';
import { User } from '@angular/fire/auth';

@Component({
    selector: 'app-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.scss'],
    standalone: false
})
export class UserComponent {
  @Input() user!: User | null;
  @Output() signOut: EventEmitter<void> = new EventEmitter<void>();
  public routes: typeof routes = routes;

  public signOutEmit(): void {
    this.signOut.emit();
  }

  firstUserLetter() {
    return ((this.user?.displayName || this.user?.email) || '')[0].toUpperCase();
  }

  avatar() {
    return this.user && this.user.photoURL && this.user.photoURL.length
      ? this.user.photoURL
      : './assets/profile.png';
  }
}
